

// Bonga roles: tenant users are either a company admin or a member.
// value 1 → admin (isCompanyAdmin), value 3 → member. (Legacy GROUPLEAD/2 retired —
// per-user list access is now an explicit ACL, not a role; see migration plan G7.)
export const ROLES = [
    {
      text: 'ADMIN',
      value: 1,
    },
    {
      text: 'MEMBER',
      value: 3,
    },
  ];
  